import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { MenuModel } from '@models/menu/menu.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private readonly menuApi = `${environment.caisseApiUrl}/menus`;
  private readonly httpService = inject(HttpService);

  getMenus(companyId: number): Observable<MenuModel[]> {
    return this.httpService
      .get<
        MenuModel[]
      >(!environment.isFullOnline ? `${this.menuApi}/company/${companyId}` : `${this.menuApi}/${companyId}/qdm`)
      .pipe(map((menus) => menus.map((menu) => this.#withResolvedLogos(menu))));
  }

  #withResolvedLogos(menu: MenuModel): MenuModel {
    return {
      ...menu,
      components: menu.components.map((component) => ({
        ...component,
        courses: component.courses.map((course) => ({
          ...course,
          allergens: course.allergens?.map((allergen) => ({
            ...allergen,
            logo: allergen.logo
              ? !environment.isFullOnline
                ? this.#toLocalUrl(allergen.logo)
                : this.#toOnlineUrl(allergen.logo, 'allergen')
              : allergen.logo,
          })),
          labels: course.labels?.map((label) => ({
            ...label,
            logo: label.logo
              ? !environment.isFullOnline
                ? this.#toLocalUrl(label.logo)
                : this.#toOnlineUrl(label.logo, 'label')
              : label.logo,
          })),
        })),
      })),
    };
  }

  #toLocalUrl(url: string): string {
    const { pathname } = new URL(url, environment.caisseApiUrl);
    return `${environment.caisseApiUrl.replace(/\/api$/, '')}${pathname}`;
  }

  #toOnlineUrl(url: string, type: 'allergen' | 'label'): string {
    const { pathname } = new URL(url, environment.caisseApiUrl);
    const filename = pathname.split('/').pop();
    return `${environment.caisseApiUrl}/menus/${type}/${filename}`;
  }
}
